import './styles.scss';

export default {
    name: 'ColorDropdown',

    data() {
        return {
            current: '',
        };
    },

    methods: {
        chooseColor(color) {
            this.current = color;
            this.$ionic.popoverController.dismiss(color);
        },
    }
};